<template>
<div class="onselef" >
  <el-dialog :visible.sync="visible" width="50%" size="mini" :title="title">
    <div style="margin-top: -35px">
      <div style="width: 570px">
      <autocomplete :areaName.sync="onselfForm.areaName" :areaCode="onselfForm.areaCode"  :code.sync="onselfForm.code" formSize="mini"></autocomplete>
      </div>
      <el-form :model="onselfForm" size="mini" :inline="true" :rules="onselfRules" ref="onselfForm"  label-width="80px">
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker
            class="dataPicker"
            v-model="onselfForm.createDate"
            type="date"
            @change="changeDate"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp" style="width: 200px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="找车人" prop="type" v-if="!usertype">
          <el-select style="width: 200px" v-model="onselfForm.type" placeholder="请选择找车人" size="mini">
            <el-option v-for="item in appInfo.userList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
            <el-option label="自己上车" value="2"/>
            <el-option label="合车" value="3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="经理:" prop="supplyId">
          <el-select  style="width: 200px" filterable clearable @change="selectSupply" @clear="clearSupply" :filter-method="searchSupply" value-key="supplyId" v-model="supply"  placeholder="请选择经理,可以输入手机号快速查找">
            <el-option :loading="loading" v-for="item in options" :key="item.supplyId" :label="item.name" :value="item">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.contact }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="吨位" prop="ton">
          <el-input  style="width: 200px" type="number" v-model.number="onselfForm.ton" auto-complete="off" placeholder="请输入">
            <template slot="append">吨</template>
          </el-input>
        </el-form-item>
        <el-form-item  label="订车运费" prop="freightSub">
          <el-input   style="width: 200px" type="number" auto-complete="off" placeholder="请输入订车运费" v-model="onselfForm.freightSub">
            <el-select slot="append" v-model="onselfForm.priceUnit" placeholder="请选择" class="unit">
              <el-option label="元/吨" value="元/吨"></el-option>
              <el-option label="元/趟" value="元/趟"></el-option>
              <el-option label="元/箱" value="元/箱"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item  label="实际运费" prop="freight">
          <el-input   style="width: 200px" type="number" auto-complete="off" placeholder="请输入运费" v-model="onselfForm.freight">
            <el-select slot="append" v-model="onselfForm.priceUnit" placeholder="请选择" class="unit">
              <el-option label="元/吨" value="元/吨"></el-option>
              <el-option label="元/趟" value="元/趟"></el-option>
              <el-option label="元/箱" value="元/箱"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item  label="收款" prop="total">
          <el-input  style="width: 200px" type="number" v-model.number="onselfForm.total" placeholder="多少钱">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNumber">
          <el-autocomplete
            :fetch-suggestions="queryCar"
            placeholder="请输入车牌号码"
            @select="handleSelectCar"
            v-model="onselfForm.carNumber"
            :trigger-on-focus="false"
            style="width: 200px"
            @blur="blurCarNumber"
          >
            <template slot-scope="{ item }">
                <div class="name" v-if="item.count >0"><i style="color: #d53131">{{ item.carNumber }}</i>&nbsp;<i style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</i>{{item.title}}</div>
                <div class="name" v-else>{{ item.carNumber }}&nbsp;<span style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</span><i style="color: red;font-weight: 800">{{item.title}}</i></div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="车主电话"  prop="phone">
          <el-autocomplete
            :fetch-suggestions="queryOwner"
            placeholder="请输入车主电话"
            @select="handleSelectOwner"
            v-model="onselfForm.phone"
            :trigger-on-focus="false"
            style="width: 200px"
            @blur="blurOwnerPhone"
          >
            <template slot-scope="{ item }">
              <div class="name"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }}{{ item.name }}&nbsp;{{item.title}}</i><span v-else>{{ item.phone }}{{ item.name }}&nbsp;<i style="color: red;font-weight: 800">{{item.title}}</i></span></div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="车主姓名" prop="driverName">
          <el-input placeholder="车主姓名" style="width: 200px" v-model="onselfForm.driverName" auto-complete="off" >
          </el-input>
        </el-form-item>
        <el-form-item label="司机电话">
          <el-autocomplete
            :fetch-suggestions="queryDriver"
            placeholder="请输入司机电话"
            @select="handleSelectDriver"
            v-model="onselfForm.driverSubPhone"
            :trigger-on-focus="false"
            style="width: 200px"
            @blur="blurDriverPhone"
          >
            <template slot-scope="{ item }">
              <div class="name"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }}{{ item.name }}&nbsp;{{item.title}}</i><span v-else>{{ item.phone }}{{ item.name }}&nbsp;<i style="color: red;font-weight: 800">{{item.title}}</i></span></div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="司机姓名">
          <el-input  placeholder="司机姓名" style="width: 200px" v-model="onselfForm.driverSubName" auto-complete="off" >
          </el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input  placeholder="家庭住址" style="width: 200px" v-model="onselfForm.address" auto-complete="off" >
          </el-input>
        </el-form-item>
        <el-form-item label="身份证号"  prop="IDCard">
          <el-input  placeholder="请输入身份证号" style="width: 200px" v-model="onselfForm.IDCard" auto-complete="off" >
          </el-input>
        </el-form-item>
        <el-form-item label="上车备注" prop="remark">
          <el-input type="textarea" style="width: 200px" autosize v-model="onselfForm.remark" placeholder="对此货源备注的信息"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible=false">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="create('onselfForm')">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getDriverForPhone, selectDriver, updateDriver } from '../api/driver'
import { getCarForNumber, selectCar } from '../api/car'
import { getAppInfo } from '../api/app'
import { quickPage } from '../api/receiptOrder'
import autocomplete from './autocompleteInput'
import {Message} from 'element-ui'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    apps: String,
    title: {
      type: String,
      default: '快速开单'
    },
    usertype: [String, Number]
  },
  data () {
    return {
      appInfo: {},
      onselfForm: {
        areaName: '',
        supplyId: '',
        ton: '',
        appId: '',
        code: [],
        areaCode: '',
        categoryId: '',
        driverId: '',
        priceUnit: '元/吨',
        freight: '',
        driverName: '',
        IDCard: '',
        total: '',
        phone: '',
        carNumber: '',
        carId: '',
        address: '',
        remark: '',
        type: '',
        createDate: '',
        freightSub: '',
        driverSubId: '',
        driverSubPhone: '',
        driverSubName: ''
      },
      owner: {},
      driver: {},
      loading: false,
      supplyList: [],
      supply: {
        categoryId: '',
        contact: '',
        name: '',
        supplyId: ''
      },
      options: [],
      onselfRules: {
        type: [
          {required: true, message: '找车人不能为空', trigger: 'change'}
        ],
        createDate: [
          {required: true, message: '时间不能为空', trigger: 'blur'}
        ],
        supplyId: [
          {required: true, message: '经理不能为空', trigger: 'change'}
        ],
        freight: [
          {required: true, message: '运费不能为空', trigger: 'blur'}
        ],
        freightSub: [
          {required: true, message: '运费不能为空', trigger: 'blur'}
        ],
        ton: [
          {required: true, message: '吨位不能为空', trigger: 'blur'},
          {type: 'number', message: '吨位必须为数字值'}
        ],
        total: [
          {required: true, message: '收款不能为空', trigger: 'blur'},
          {type: 'number', message: '必须为数字值'}
        ],
        driverName: [
          {required: true, message: '车主姓名不能为空', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '电话不能为空', trigger: 'blur'},
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '订车电话格式不正确', trigger: ['blur', 'change']}
        ],
        carNumber: [
          {required: true, message: '车牌号码不能为空', trigger: 'blur'},
          {
            pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/,
            message: '车牌号码格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        IDCard: [
          {pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, message: '身份证号不正确', trigger: ['blur']}
        ]
      },
      visible: false
    }
  },
  computed: {
  },
  watch: {
    show (val) {
      this.visible = val
      if (val) {
        this.$nextTick(() => {
          this.$refs.onselfForm.resetFields()
          this.onselfForm.address = ''
          this.onselfForm.areaName = ''
          this.onselfForm.areaCode = ''
          this.onselfForm.code = []
        })
      }
    },
    usertype: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.onselfForm.type = val.toString()
          })
        }
      },
      immediate: true
    },
    visible (val) {
      this.$emit('update:show', val)
    },
    apps: {
      handler (val) {
        this.onselfForm.appId = val
        this.getSupplyList(val)
      },
      immediate: true
    }
  },
  created () {
  },
  methods: {
    selectSupply (item) {
      this.onselfForm.supplyId = item.supplyId
      this.onselfForm.categoryId = item.categoryId
    },
    clearSupply () {
      this.options = this.supplyList
    },
    searchSupply (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.supplyList.filter(item => {
            return item.contact.indexOf(query) >= 0
          })
        }, 200)
      } else {
        this.options = this.supplyList
      }
    },
    create (onselfForm) {
      let _this = this
      _this.loading = true
      this.onselfForm.supplyId = this.supply.supplyId
      this.onselfForm.categoryId = this.supply.categoryId
      this.$refs[onselfForm].validate((valid) => {
        this.owner.address = this.onselfForm.address
        this.owner.idcard = this.onselfForm.IDCard
        this.owner.driverId = this.onselfForm.driverId
        this.owner.name = this.onselfForm.driverName
        this.owner.phone = this.onselfForm.phone
        updateDriver(this.onselfForm.driverId, this.owner)
        if (_this.onselfForm.driverSubId != null) {
          this.driver.idcard = this.onselfForm.IDCard
          this.driver.driverId = this.onselfForm.driverSubId
          this.driver.name = this.onselfForm.driverSubName
          this.driver.phone = this.onselfForm.driverSubPhone
          updateDriver(this.onselfForm.driverSubId, this.driver)
        }
        if (valid && this.onselfForm.code.length > 0) {
          this.onselfForm.areaCode = this.onselfForm.code[this.onselfForm.code.length - 1]
          quickPage(this.onselfForm).then((response) => {
            _this.$router.push({path: './receiptList', query: {receiptId: response.data.data.receiptId}})
            _this.loading = false
          }).catch(() => {
            _this.loading = false
            _this.visible = false
          })
        } else {
          _this.loading = false
        }
      })
    },
    queryCar (queryString, cb) {
      let _this = this
      this.onselfForm.carId = ''
      getCarForNumber(queryString, _this.apps).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            carNumber: queryString,
            name: '',
            title: '新牌号,点击新增',
            empty: true,
            phone: '',
            driverId: '',
            address: ''
          }])
        }
      })
    },
    handleSelectCar (item) {
      if (item.empty) {
        selectCar(item.carNumber, this.apps).then((response) => {
          let carVo = response.data.data
          this.onselfForm.carNumber = carVo.carNumber
          this.onselfForm.carId = carVo.carId
        }).catch(() => {
          Message({
            message: '车牌号新增失败，请检查格式是否正确',
            type: 'error',
            duration: 5 * 1000
          })
        })
      } else {
        if (item.driverId !== null) {
          this.onselfForm.driverId = item.driverId
          this.onselfForm.IDCard = item.idcard
          this.onselfForm.address = item.address
          this.onselfForm.driverName = item.name
          this.onselfForm.phone = item.phone
        }
        this.onselfForm.carId = item.carId
        this.onselfForm.carNumber = item.carNumber
      }
    },
    queryOwner (queryString, cb) {
      this.onselfForm.driverId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: queryString,
            name: '',
            title: '新号码,点击新增',
            empty: true,
            driverId: ''
          }])
        }
      })
    },
    handleSelectOwner (item) {
      if (item.empty) {
        selectDriver(item.phone).then((response) => {
          let driver = response.data.data
          this.onselfForm.phone = driver.phone
          this.onselfForm.driverId = driver.driverId
        })
      } else {
        this.onselfForm.IDCard = item.idcard
        this.onselfForm.driverId = item.driverId
        this.onselfForm.address = item.address
        this.onselfForm.driverName = item.name
        this.onselfForm.phone = item.phone
      }
    },
    queryDriver (queryString, cb) {
      this.onselfForm.driverSubId = ''
      getDriverForPhone(queryString).then((response) => {
        if (response.data.data.records.length > 0) {
          cb(response.data.data.records)
        } else {
          // eslint-disable-next-line
          cb([{
            phone: queryString,
            name: '',
            title: '新号码,点击新增',
            empty: true,
            driverSubId: ''
          }])
        }
      })
    },
    handleSelectDriver (item) {
      if (item.empty) {
        selectDriver(item.phone).then((response) => {
          let driver = response.data.data
          this.onselfForm.driverSubPhone = driver.phone
          this.onselfForm.driverSubId = driver.driverId
        })
      } else {
        this.onselfForm.driverSubId = item.driverId
        this.onselfForm.driverSubName = item.name
        this.onselfForm.driverSubPhone = item.phone
      }
    },
    blurCarNumber () {
      if (this.onselfForm.carNumber.length === 7) {
        selectCar(this.onselfForm.carNumber, this.onselfForm.appId).then((response) => {
          let carVo = response.data.data
          this.onselfForm.carNumber = carVo.carNumber
          this.onselfForm.carId = carVo.carId
        })
      }
    },
    blurOwnerPhone () {
      if (this.onselfForm.phone.length === 11) {
        selectDriver(this.onselfForm.phone).then((response) => {
          let driver = response.data.data
          this.onselfForm.phone = driver.phone
          this.onselfForm.driverId = driver.driverId
        })
      }
    },
    blurDriverPhone () {
      if (this.onselfForm.driverSubPhone.length === 11) {
        selectDriver(this.onselfForm.driverSubPhone).then((response) => {
          let driver = response.data.data
          this.onselfForm.driverSubPhone = driver.phone
          this.onselfForm.driverSubId = driver.driverId
        })
      }
    },
    getSupplyList (appId) {
      let _this = this
      if (this.wei.isNull(appId)) {
        return
      }
      setTimeout(() => {
        getAppInfo(appId).then((response) => {
          _this.appInfo = response.data.data
          _this.supplyList = _this.appInfo.supplyList
          _this.options = _this.supplyList
        })
      }, 500)
    },
    changeDate (data) {
      if (new Date(data).format('yyyy-MM-dd') == new Date().format('yyyy-MM-dd')) {
        this.onselfForm.createDate = new Date().getTime()
      }
    }
  },
  components: {
    autocomplete
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .onselef
    .unit
      width 85px !important
</style>
